import React from 'react'
import PropTypes from 'prop-types'
import { compose, setPropTypes, defaultProps } from 'recompose'
import { StatusTagContainer } from './styled'

const StatusTag = (props) => {
  const { 
    status, 
    statusName, 
    isBilling=false, 
    style={} 
  } = props
  return (
    <StatusTagContainer status={status} style={style} isBilling={isBilling}>
      {statusName}
    </StatusTagContainer>
  )
}

const propTypes = {
  status: PropTypes.number,
  statusName: PropTypes.string,
}

const defaultProp = {
  status: 0,
  statusName: 'N/A'
}

const enhance = compose(
  setPropTypes(propTypes),
  defaultProps(defaultProp),
)

export default enhance(StatusTag)